import React from "react";

export default function Footer() {
  return (
    <footer className="bg-white">
      <div className="">
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> */}
        <div className="py-2 border-t border-gray-100">
          <p className="text-sm text-gray-400 text-center">
            © 2025 Webgarh Solutions. All analytics reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
